export default __webpack_public_path__ + "static/media/Karena-Soderborg.d5379b40.jpg";